// src/lib/sentry.js — Sentry client (browser) pour l'app React.
// Miroir de lib/logger.js côté serveur (qui utilise @sentry/node).
// No-op silencieux si REACT_APP_SENTRY_DSN absent (dev local par défaut).
//
// PERF (audit bundle 2026-07) : imports NOMMÉS uniquement — l'ancien
// `import * as SentryNS` + ré-export du namespace tuait le tree-shaking
// et embarquait Replay/Feedback (~120 kB gzip) jamais utilisés (sample
// rates à 0). Ne JAMAIS ré-introduire de namespace-import/ré-export ici :
// tout nouveau besoin = ajouter l'import nommé correspondant.

import { init, captureMessage, ErrorBoundary } from '@sentry/react'

let sentryReady = false

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN
  const env = process.env.NODE_ENV || 'development'
  if (!dsn) {
    console.log(`[sentry] désactivé : REACT_APP_SENTRY_DSN absent (env=${env})`)
    return
  }
  try {
    init({
      dsn,
      environment: env,
      tracesSampleRate: 0,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0,
    })
    sentryReady = true
    console.log(`[sentry] initialisé (env=${env})`)
  } catch (e) {
    console.error('[sentry] init failed:', e.message)
  }
}

// Capture une garde déclenchée (analogue de logError côté serveur).
// No-op si Sentry pas init — safe à appeler en dev sans DSN.
export function captureGarde(ctx, msg, extra) {
  if (!sentryReady) return
  try {
    captureMessage(String(msg), {
      level: 'error',
      tags: { ctx },
      extra: extra || {},
    })
  } catch (e) {
    console.error('[sentry] capture failed:', e.message)
  }
}

// API publique conservée : `Sentry.ErrorBoundary` (consommé par src/index.js).
// Objet restreint aux membres réellement utilisés — PAS le namespace complet
// (cf. note perf en tête de fichier).
export const Sentry = { ErrorBoundary }
